<template>
  <div class="circular-progress-container"
       :style="{ width: size + 'px', height: size + 'px' }">
    <svg viewBox="0 0 100 100">
      <!-- 背景圆 -->
      <circle class="circular-progress-background"
              cx="50"
              cy="50"
              r="45"
              fill="transparent"
              stroke-width="10"
              stroke="#e0e0e0" />
      <!-- 进度圆 -->
      <circle class="circular-progress-bar"
              cx="50"
              cy="50"
              r="45"
              fill="transparent"
              stroke-width="10"
              :stroke-dasharray="dashArray"
              :stroke-dashoffset="dashOffset"
              stroke-linecap="round"
              :stroke="color" />
    </svg>
    <!-- 中心文字 -->
    <div class="progress-text">
      <span>{{ percentage }}%</span>
      <span class="sub-text">正确率</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CircularProgress',
  props: {
    size: {
      type: Number,
      default: 100, // 圆形进度条的大小
    },
    percentage: {
      type: Number,
      required: true, // 必须传递的百分比值
      validator(value) {
        return value >= 0 && value <= 100;
      }
    },
    color: {
      type: String,
      default: '#4caf50', // 进度条的颜色，默认为绿色
    }
  },
  computed: {
    circumference() {
      return 2 * Math.PI * 45; // 圆的周长
    },
    dashArray() {
      return this.circumference; // 整个圆周长
    },
    dashOffset() {
      return this.circumference - (this.percentage / 100) * this.circumference;
    }
  }
};
</script>

<style lang="less" scoped>
.circular-progress-container {
  position: relative;
  display: inline-block;
}

.circular-progress-container svg {
  transform: rotate(-90deg); /* 使进度从顶部开始 */
  width: 100%;
  height: 100%;
}

.circular-progress-container {
  .progress-text {
    display: flex;
    align-items: center;
    flex-direction: column;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 24px;
    font-weight: bold;
    color: #333;
    .sub-text {
      font-size: 14px;
      color: #999;
      font-weight: normal;
    }
  }
}

.debug-info {
  position: absolute;
  bottom: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.8);
  padding: 5px;
  font-size: 12px;
}
</style>